const getUserWithRoles = {
    computed: {
        user() {
            return this.$store.state.user.data
        },
    },
    methods: {

    }
}

export default getUserWithRoles
